import React, { Component } from 'react'
import check from "../../assets/check.svg";
import Cookies from 'js-cookie';
import upload from "../../assets/Subir.svg"

import eliminar from "../../assets/eliminar.svg";
import subaacfe from "../../assets/subiracuerdoFE.svg";
import subaacfm from "../../assets/subiracuerdoFM.svg";
import rostoimg from "../../assets/FotoPERSONAL.svg"
import cedimg from "../../assets/FotoCEDULA.svg"
import Modal from './Modal';
import ModalXL from './ModalXL';
import axios from "axios";
import "../../css/Acuerdo.css"
import Header from './Header.js'
import Footer from './Footer.js'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faCheckCircle, faTimesCircle, faCheck } from "@fortawesome/free-solid-svg-icons";
import Camara from "./Camara.js"
import pdf from "../../../src/ruc.pdf"
import Visualizarpdf from "../components/Visualizarpdf";
import FormRegistroContrasenia from './FormRegistroContrasenia';
import { Navigate } from 'react-router-dom';
import equis from "../../assets/eliminar.svg";
import alerta from "../../assets/alarma.svg";
import anuncioico from "../../assets/AnuncioICO.svg";

import RenderpdfAdmision from "../components/renderPDFAdmision.js"
import CenteredWrapper from '../components/CenteredWrapper.js';


export class AcuerdoAdmisiones extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showEnvAcdRect:false,
            aceptoAcuerdo: false,
            modalPrevAcuerdoGen: this.props.modalPrevAcuerdoGen,
            mostrarNombre:false,
            IsFirmadoElect:false,
            modalFirmaGeneralExitosa: false,
            firmadoGeneral: this.props.firmadoGeneral,
            modalFirmaManual: false,
            modalFirmaManualActualizararch:false,
            verbtngeneral: this.props.verbtngeneral,
            modalFirmaElectronica: false,
            modalFManualExitosa: false,
            modalFManualExitosaTipoA: false,
            modalActualizaciónDocsExitosa: false,

            modalFElectricaExitosa: false,
            modalCamararostro: false,
            modalCamaracedula: false,
            modalSubirPdf: false,
            modalNoAcepACGeneral: false,
            modalNoAcepACGeneralprev: false,
            iconGuardRostroExito: false,
            iconGuardCedulaExito: false,
            isvalidimgpersonasub: false,
            isvalidimgtarjetasub:false,
            isvalidcontratosub: false,
            iconGuardPdfExito: false,
            iconChooseFirma: false,
            actFirmaElec: false,
            actFirmaElecInter: false,
            showPassword: false,
            activebutton: true,
            activebuttonpdf: true,
            activebutton1: true,
            IsAcuerdoDescargado: false,
            modalMensaje: "",
            idAcFirmaElec: "",
            acuerdob64: "",
            mensaje_titulo: this.props.mensaje_titulo,
            datosUsuario: {
                //SECCIÓN DE LA CUENTA ELECTRÓNICA
                id: this.props.id,
                nombres: this.props.nombres,
                apellidos: this.props.apellidos,
                identificacion: this.props.identificacion,
                usuario_sugerido: this.props.usuario_sugerido,
                //nombres: "pepito pivuawe",
                //apellidos: "gomez rendom",
                //identificacion: "0931087209",
                //usuario_sugerido: "aiarias",
                alias_sugerido: this.props.alias_sugerido,
                correoAlterno: this.props.correoAlterno,
                rol: this.props.rol,
                telefono: this.props.telefono,
                unidad: this.props.unidad,
                password: this.props.password,
                //SECCIÓN DE SOLICITUD MANUAL
                estado: this.props.estado,
                Motivo: this.props.Motivo,
                tipoForm: this.props.tipoForm,
                infoSolicitud: this.props.infoSolicitud,
            },
            contra: {
                contrasena: "",
                contrasenaCumple: false,
                repetirContraCumple: false,
                terminos: "",
            },
            fotoRostro: '',
            fotoCedula: '',
            pdfData: null,

            // modalSugerencia: {
            modalError: {
                show: false,
                titulo: "",
                mensaje: "",
                imagen: equis,
            },
            modalErrorAcuerdoGen:{
                show: false,
                titulo: "",
                mensaje: "",
                imagen: equis,
            },
            renderNavigateLogin: false,
            base64FE: "",
           // pwdFirmaElectronica: "",
            fecha: new Date(),
            verbtngeneralElectronica: this.props.verbtngeneralElectronica,
        };

        this.cambiarEstado = this.cambiarEstado.bind(this);

        this.renderRegistro = this.renderRegistro.bind(this);

        



        this.abrirModalFManualExitosa = this.abrirModalFManualExitosa.bind(this);
        this.cerrarModalFManualExitosa = this.cerrarModalFManualExitosa.bind(this); 

        this.abrirModalActualizaciónDocsExitosa = this.abrirModalActualizaciónDocsExitosa.bind(this);
        this.cerrarModalActualizaciónDocsExitosa = this.cerrarModalActualizaciónDocsExitosa.bind(this);

        this.abrirModalNoAcepACGeneral = this.abrirModalNoAcepACGeneral.bind(this);
        this.cerrarModalNoAcepACGeneral = this.cerrarModalNoAcepACGeneral.bind(this);

        this.abrirModalNoAcepACGeneralPrev = this.abrirModalNoAcepACGeneralPrev.bind(this);
        this.cerrarModalNoAcepACGeneralPrev = this.cerrarModalNoAcepACGeneralPrev.bind(this);

        this.abrirModalCamararostro = this.abrirModalCamararostro.bind(this);
        this.cerrarModalCamararostro = this.cerrarModalCamararostro.bind(this);

        this.abrirModalCamaracedula = this.abrirModalCamaracedula.bind(this);
        this.cerrarModalCamaracedula = this.cerrarModalCamaracedula.bind(this);

        this.abrirModalSubirPdf = this.abrirModalSubirPdf.bind(this);
        this.cerrarModalSubirPdf = this.cerrarModalSubirPdf.bind(this);

        this.showiconGuardRostroExito = this.showiconGuardRostroExito.bind(this);
        this.showiconGuardCedulaExito = this.showiconGuardCedulaExito.bind(this);
        this.showiconGuardPdfExito = this.showiconGuardPdfExito.bind(this);


        this.mostrarContrasena = this.mostrarContrasena.bind(this);

        this.abrirModalError = this.abrirModalError.bind(this);
        this.cerrarModalError = this.cerrarModalError.bind(this);

        this.abrirModalErrorGen = this.abrirModalErrorGen.bind(this);
        this.cerrarModalErrorGen = this.cerrarModalErrorGen.bind(this);

        this.activebuttonf = this.activebuttonf.bind(this);
        this.disabledbuttonf = this.disabledbuttonf.bind(this);


        this.activebuttonpdf = this.activebuttonpdf.bind(this);
        this.disabledbuttonpdf = this.disabledbuttonpdf.bind(this);

        this.abrirModalFirmaGeneralExitosa = this.abrirModalFirmaGeneralExitosa.bind(this);
        this.cerrarModalFirmaGeneralExitosa = this.cerrarModalFirmaGeneralExitosa.bind(this);

        this.cerrarModalPrevGen = this.cerrarModalPrevGen.bind(this);
        this.abrirModalPrevGen = this.abrirModalPrevGen.bind(this);

        var servicio = localStorage.getItem('servicio');        
        //console.log(servicio);
    }


    cerrarModalPrevGen() {
        this.setState({
            modalPrevAcuerdoGen: false,
        });
    }

    abrirModalPrevGen() {
        this.setState({
            modalPrevAcuerdoGen: true,
        });
    }

    activebuttonf() {
        this.setState({ activebutton: true });
    }

    disabledbuttonf() {
        this.setState({ activebutton: false });
    }


    activebuttonpdf() {
        this.setState({ activebuttonpdf: true });
    }

    disabledbuttonpdf() {
        this.setState({ activebuttonpdf: false });
    }


    activebuttonf1() {
        this.setState({ activebutton1: true });
    }

    disabledbuttonf1() {
        this.setState({ activebutton1: false });
    }
    mostrarContrasena(e) {
        e.preventDefault();
        this.setState({ showPassword: !this.state.showPassword });
    }
    showiconGuardRostroExito() {
        this.setState({
            iconGuardRostroExito: true,
            actFirmaElec: true,
            isvalidimgpersonasub: true
        });
        ///this.setState({  })
    }

    showiconGuardCedulaExito() {
        this.setState({
            iconGuardCedulaExito: true,
            actFirmaElec: true,
            isvalidimgtarjetasub: true
        });
        //this.setState({ actFirmaElec: true })


    }
    showiconGuardPdfExito() {
        this.setState({
            iconGuardPdfExito: true,
            actFirmaElec: true,
            isvalidcontratosub:true,
            })
        //this.setState({ actFirmaElec: true })

    }

    abrirModalCamararostro() {
        this.setState({ modalCamararostro: true })
    }

    cerrarModalCamararostro() {
        this.setState({ modalCamararostro: false })
    }

    abrirModalCamaracedula() {
        this.setState({ modalCamaracedula: true })
    }

    cerrarModalCamaracedula() {
        this.setState({ modalCamaracedula: false })
    }

    abrirModalSubirPdf() {
        this.setState({ modalSubirPdf: true })
    }

    cerrarModalSubirPdf() {
        this.setState({ modalSubirPdf: false })
    }


    abrirModalFManualExitosa() {
        this.setState({ modalFManualExitosa: true })
    }


    cerrarModalActualizaciónDocsExitosa() {
        this.setState({ modalActualizaciónDocsExitosa: false });
        //window.location.href = "/Inicio";
        window.location.href = "https://academico.admision.espol.edu.ec/";
        
    }

    abrirModalActualizaciónDocsExitosa() {
        this.setState({
            modalActualizaciónDocsExitosa: true,
            modalFirmaManualActualizararch: false
        })
    }


    cerrarModalFManualExitosa() {
        this.setState({ modalFManualExitosa: false })
        this.setState({ renderNavigateLogin: true })
    }


    abrirModalFManualExitosaTipoA() {
        this.setState({ modalFManualExitosaTipoA: true })
    }


    cerrarModalFManualExitosaTipoA() {
        this.setState({ cerrarModalFManualExitosaTipoA: false })
        //this.setState({ renderNavigateLogin: true })
    }

    abrirModalNoAcepACGeneral() {
        this.cerrarSesion();
        this.setState({
            modalNoAcepACGeneralprev: false,
            modalNoAcepACGeneral: true,
        })
    }

    cerrarModalNoAcepACGeneral() {
        this.setState({ modalNoAcepACGeneral: false });
        this.redireccion(2);
    }


    abrirModalNoAcepACGeneralPrev() {
        this.setState({ modalNoAcepACGeneralprev: true })
    }

    cerrarModalNoAcepACGeneralPrev() {
        this.setState({ modalNoAcepACGeneralprev: false });
        //window.location.href = "/Inicio";
    }


    abrirModalFirmaGeneralExitosa() {
        this.setState({ modalFirmaGeneralExitosa: true });
    }

    descargarAcuerdoFirmaManual = () => {
        //console.log("acuerdo descargado");
        this.setState({
            IsAcuerdoDescargado: true
        });

    }

    redireccion(){
      window.location.href = 'https://academico.admision.espol.edu.ec/';
    }

    /*ADMISIONES*/
    cerrarModalFirmaGeneralExitosa() {
        this.setState({ modalFirmaGeneralExitosa: false });
        this.cerrarSesion();
        this.redireccion();
    }


    abrirModalError() {
        this.setState({
            modalError: {
                ...this.state.modalSugerencia,
                show: true
            }
        });
    }

    cerrarModalError() {
        this.setState({
            modalError: {
                titulo: "",
                mensaje: "",
                imagen: "",
                show: false
            }
        });
    }

    abrirModalErrorGen() {
        this.setState({
            modalErrorAcuerdoGen: {
                ...this.state.modalSugerencia,
                show: true
            }
        });
    }

    cerrarModalErrorGen() {
        this.setState({
            modalErrorAcuerdoGen: {
                titulo: "",
                mensaje: "",
                imagen: "",
                show: false
            }
        },()=>{
            this.redireccion(2);
        });
    }

    handlerDatosFormRegistro = async (e) => {
        await this.setState({
            contra: {
                ...this.state.contra,
                [e.target.name]: e.target.value,
                terminos: e.target.checked
            }
        })
        //console.log(this.state.contra);

    }


    handlerCheckPrev = async (e) => {
        await this.setState({
            aceptoAcuerdo: e.target.checked,

        })
    }

    cambiarEstado(valor, contraCumple, repetirContraCumple) {
        this.setState({
            contra: {
                ...this.state.contra,
                contrasena: valor,
                contrasenaCumple: contraCumple,
                repetirContraCumple: repetirContraCumple
            }
        })
        //console.log("CAMBIAR ESTADO");
        //console.log(this.state.contra);
    }

    renderRegistro(e) {
        e.preventDefault();

        this.props.renderFormRegistro(false);
        //console.log("cambio form registro contraseña");
    }

    /*Admisiones*/
    PostFirmarAcuerdoGen = async (e) => {
        //console.log("PostFirmarAcuerdoGen");
        e.preventDefault();
        this.disabledbuttonf();
      
       var signDoc = {
            nombre: this.state.datosUsuario.nombres,
            apellido: this.state.datosUsuario.apellidos,
            identificacion: this.state.datosUsuario.identificacion,
            acuerdoBase64: this.state.acuerdob64,
            firmaBase64: this.state.base64FE,
       }
        axios.post(`${process.env.REACT_APP_API}api/PersonaDago/uploadsignagreement`, signDoc)
            .then(resp => {
                let enlace = resp.data;
                //console.log("El enlace es: ", enlace);
                if (resp.status == 200 && resp.data != " ") {
                    // guardar el resgistro en la tabla.
                    let datos = {
                        estado: 1,
                        aceptodatospers: 1,
                        aceptomedelect: 0,
                        rutaacuerdodatospersfirmado: enlace,
                        rutaacuerdomedelectfirmado: "",
                        identificacion: this.state.datosUsuario.identificacion
                    }
                    axios.post(`${process.env.REACT_APP_API}api/PersonaDago/signautoagreement`, datos)
                        .then(resp => {
                           // console.log(resp);
                            this.abrirModalFirmaGeneralExitosa();
                            this.activebuttonf();
                        }).catch(error => {
                           // console.log(error.response.data);
                            this.setState({
                                modalErrorAcuerdoGen: {
                                    show: true,
                                    titulo: "Error al guardar el registro de la firma",
                                    mensaje: error.response.data,
                                    imagen: equis,
                                }
                            });
                            this.activebuttonf();
                        })
                }
            }).catch(error => {
                //console.log(error.message);
                this.setState({
                    modalErrorAcuerdoGen: {
                        show: true,
                        titulo: "Error al guardar el documento firmado",
                        mensaje: "Existe un problema al guardara el acuerdo. Por favor, intentarlo mas tarde.",
                        imagen: equis,
                    }
                    
                });
                this.activebuttonf();
            })

    }

    PostNoFirmarAcuerdoGen = async (e) => {
        //console.log("PostNoFirmarAcuerdoGen");
        e.preventDefault();
        this.disabledbuttonf1();
        //console.log("guardar registro de no firma acuerdo general");
        let datos = {
            estado: 1,
            aceptodatospers: 0,
            aceptomedelect: 0,
            rutaacuerdodatospersfirmado: "",
            rutaacuerdomedelectfirmado: "",
            identificacion: this.state.datosUsuario.identificacion
        }
        axios.post(`${process.env.REACT_APP_API}api/PersonaDago/signautoagreement`, datos)
            .then(resp => {
                this.activebuttonf1();
                this.abrirModalNoAcepACGeneral();
                //this.abrirModalNoAcepACGeneralPrev();
            }).catch(error => {
                this.setState({
                    modalErrorAcuerdoGen: {
                        show: true,
                        titulo: "Error al guardar el registro de la firma",
                        mensaje: error.response.data,
                        imagen: equis,
                    }
                });
                this.activebuttonf1();
            })
            
    }


   
    DataAcuerdo = arcb64 => {

        this.state.acuerdob64 = arcb64;
        //console.log(this.state.acuerdob64);
    }

    Dataimgrostro = dataimgros => {
        if (dataimgros === null) {
            //console.log("No es una foto adecuada del rostro.");
        } else {
            this.state.fotoRostro = dataimgros
            this.cerrarModalCamararostro();
            this.showiconGuardRostroExito();
            this.state.actRostro = true;
        }
    }

    Dataimgcedula = dataimgced => {
        //console.log("No es una foto adecuada de la cedula");
        if (dataimgced === null) {
            //console.log("No es una foto adecuada de la cedula");
        } else {
            this.state.fotoCedula = dataimgced;
            this.cerrarModalCamaracedula();
            this.showiconGuardCedulaExito();
            this.state.actCedula = true;
        }
    }

    filechoose = chosefile => {
        if (chosefile === null) {
            //console.log("No es una foto adecuada de la cedula");
        } else {
            //console.log(chosefile);
            this.state.pdfData = chosefile;
            this.cerrarModalSubirPdf();
            this.showiconGuardPdfExito();
            this.state.actDocPdf = true;
        }
    }

    handleFile = async (e) => {
        let selectedFile = e.target.files[0];
        //console.log(selectedFile);
        if (selectedFile) {
            let reader = new FileReader();
            reader.readAsDataURL(selectedFile);
            reader.onloadend = (e) => {
                this.state.base64FE = e.target.result;
                this.setState({ iconChooseFirma: true });
            }
            //console.log(e);
            //console.log(e.target.result);
        }
        else {
            //console.log('Seleccione un pdf');
        }
    }

    cerrarSesion = async () => {
        Cookies.remove("token");
        Cookies.remove("cas");
        Cookies.remove("DatosPersonalesGIA.CAS");   
    }

    render() {
        return (
            this.state.renderNavigateLogin ? <Navigate to="/inicio" /> :
                (  
                    <div>
                        <Header />
                        <CenteredWrapper>
                        <div className="acuerdo-container">
                            <div className="container">
                                <div className="row">
                                    {this.state.firmadoGeneral ?
                                        (<div>
                                            
                                            <p className="acuerdo-title">{this.state.mensaje_titulo}</p>

                                            <div className="acuerdogeneral-container">
                                                <div className="container">
                                                    <div className="row">
                                                        <div >
                                                            <p className="acuerdogeneral-subtitulo" align="justify"> <img src={anuncioico} className="acuerdogeneral-btn-logop" /> PARA SU CONOCIMIENTO</p>
                                                            <p className="acuerdogeneral-parraf" align="justify"><strong>Estimado Aspirante, en cumplimiento de la Ley Orgánica de Protección de Datos Personales, ponemos a su conocimiento el siguiente Acuerdo para el Tratamiento de sus Datos Personales: </strong></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>) :
                                        (<div>
                                            <div >
                                                <p className="acuerdo-title">{this.state.mensaje_titulo}</p>
                                            </div>

                                            <div >
                                                <p className="acuerdo-parraf" align="justify">A continuación tiene que leer y firmar el acuerdo de uso de medios electrónicos. </p>
                                            </div>
                                        </div>)
                                    }

                                </div>
                            </div>
                            <br />
                            <div className="row">
                                <div className=" col-md-1 col-lg-2 col-xl-3"></div>
                                    <div className=" col-md-10 col-lg-8 col-xl-6 acuerdo-recuadro acuerdo_admisiones" align="center">
                                    <div className="row acuerdo-recuadro-titulo mt-4" >
                                        <p><b>ACUERDO DE TRATAMIENTO DE DATOS PERSONALES</b></p>
                                        <p><b>PARA ASPIRANTES A ESTUDIANTES DE LA ESPOL</b></p>

                                    </div>
                                    {/*<div className="row acuerdo-recuadro-subtitulo" >
                                        <p><b>I.- Autorización para el almacenamiento y uso de información <br /> personal registrada en la ESPOL.</b></p>
                                    </div>*/}
                                    <div className="row mt-2 px-3 acuerdo-recuadro-texto" align="justify">
                                        <p>Cumpliendo con lo dispuesto por la Ley Orgánica de Protección de Datos Personales del Ecuador, <strong>LA ESCUELA SUPERIOR POLITÉCNICA DEL LITORAL (ESPOL)</strong>, informa a  usted como candidato/aspirante, que los datos personales proporcionados en los formularios o en cualquier otra documentación aportada durante el proceso de registro, serán tratados por  la ESPOL (responsable del tratamiento), con la finalidad de llevar a cabo el proceso de registro y gestión estudiantil, que pueden incluir nombre y apellidos, fecha de nacimiento, dirección domiciliaria, correo electrónico, información académica y cualquier otra información que sea necesaria para esta finalidad.</p>
                                    </div>
                                    <div className="row mt-2 px-3 acuerdo-recuadro-texto" align="justify">
                                        <p>Los datos objeto de tratamiento no serán cedidos o comunicados a terceros, salvo en los supuestos necesarios para el estricto y exclusivo cumplimiento o satisfacción de las finalidades antes mencionadas, así como en los legalmente previstos.</p>
                                        <p><strong>LA ESPOL</strong>, se compromete a tratar los datos personales de usted como candidato/aspirante de manera confidencial y a garantizar su seguridad mediante las medidas técnicas y organizativas necesarias para evitar su alteración, pérdida, tratamiento o acceso no autorizado.</p>
                                        <p>Sus datos serán almacenados con la finalidad de completar el proceso de admisión y registro y serán conservados el tiempo estrictamente necesario para tal fin. En caso de ser admitido a la institución, sus datos serán conservados en el tiempo que corresponda, para brindar el servicio de educación. </p>
                                        <p>El aspirante acepta y consiente el tratamiento de sus datos personales por parte de la <strong>ESPOL</strong>, para la finalidad indicada y reconoce que puede ejercer sus derechos de acceso, eliminación, rectificación, actualización y oposición, mediante solicitud dirigida al correo electrónico: <a href="mailto:datospersonales@espol.edu.ec">datospersonales@espol.edu.ec</a>. Si el titular desea conocer mas acerca del tratamiento de sus datos personales podra consultar la politica de privacidad de la institución en el siguiente link: <a target="_blank" href="https://www.espol.edu.ec/es/proteccion-datos-personales">https://www.espol.edu.ec/es/proteccion-datos-personales</a>. </p>
                                        <p>La aceptación y consentimiento del candidato/aspirante para el tratamiento de sus datos personales, será necesaria para poder participar en el proceso de registro estudiantil y, en su caso, ser considerado para la inscripción. </p>

                                        <p>En caso de que el candidato/aspirante no proporcione los datos personales requeridos o retire su consentimiento para el tratamiento de los mismos en cualquier momento durante el proceso de registro y gestión estudiantil, la ESPOL se reserva el derecho de no considerar su postulación. </p>

                                        <RenderpdfAdmision nombre={this.state.datosUsuario.nombres} apellido={this.state.datosUsuario.apellidos}
                                            identificacion={this.state.datosUsuario.identificacion} username={this.state.datosUsuario.usuario_sugerido} arcb64={this.DataAcuerdo} firmadoGeneral={this.state.firmadoGeneral} mostrarNombre={this.state.mostrarNombre} posicion="nomodal"/>
                                    </div>
                                    
                                    <div className="row my-3  justify-content-around">
                                        
                                        <div className=" col-10 col-md-8 col-xl-5" >
                                            <button onClick={this.PostNoFirmarAcuerdoGen}
                                                className="acuerdo-recuadro-buttonFE">
                                                <div className="row">
                                                    <div className=" col-2 col-md-2 col-xl-2">
                                                        <img className="acuerdo-logopFE" src={eliminar} alt="crearcuenta" />

                                                    </div>
                                                    <div className=" col-10 col-md-10 col-xl-10">
                                                        <p className="acuerdo-recuadro-texto-button">No Acepto</p>
                                                    </div>
                                                </div>
                                            </button>
                                            {!this.state.activebutton1 ?
                                                <span className="spinner-border spinner-border-sm text-primary ms-1" role="status" aria-hidden="true"></span>
                                                : null}
                                        </div>
                                        <div className="col-10 col-md-8 col-xl-5" >
                                            <button onClick={this.PostFirmarAcuerdoGen} className="acuerdo-recuadro-buttonFM">
                                                <div className="row" >
                                                    <div className="col-2 col-md-2 col-xl-2"  >
                                                        <img className="acuerdo-logopFM" src={check} alt="crearcuenta" />
                                                    </div>
                                                    <div className="col-10 col-md-10 col-xl-10">
                                                        <p className="acuerdo-recuadro-texto-button">Acepto</p>
                                                    </div>

                                                </div>
                                            </button>
                                            {!this.state.activebutton ?
                                                <span className="spinner-border spinner-border-sm text-primary ms-1" role="status" aria-hidden="true"></span>
                                                : null}
                                        </div>
                                    </div>
                                    
                                </div>
                                <div className=" col-md-1 col-lg-2 col-xl-3"></div>

                            </div>
                            </div>
                        </CenteredWrapper>
                        <Footer />
                        

                        {this.state.modalError.show &&
                            <Modal isOpen={this.state.modalError.show} cerrarModal={this.cerrarModalError} verBoton={true} textoBoton="ACEPTAR" >
                                <p className='text-center'><strong>{this.state.modalError.titulo}</strong></p>
                                <div align="center">
                                    <img className="registroContra-check" src={this.state.modalError.imagen} alt="Exitoso"></img>
                                </div>
                                <p className='text-center'>{this.state.modalError.mensaje}</p>
                            </Modal>
                        }
                        {this.state.modalErrorAcuerdoGen.show &&
                            <Modal isOpen={this.state.modalErrorAcuerdoGen.show} cerrarModal={this.cerrarModalErrorGen} verBoton={true} textoBoton="ACEPTAR" >
                                <p className='text-center'><strong>{this.state.modalErrorAcuerdoGen.titulo}</strong></p>
                                <div align="center">
                                    <img className="registroContra-check" src={this.state.modalErrorAcuerdoGen.imagen} alt="Exitoso"></img>
                                </div>
                                <p className='text-center'>{this.state.modalErrorAcuerdoGen.mensaje}</p>
                            </Modal>
                        }

                        {
                            this.state.modalFManualExitosa &&
                            <Modal isOpen={this.state.modalFManualExitosa} cerrarModal={this.cerrarModalFManualExitosa} verBoton={false} textoBoton="SIGUIENTE" >
                                <p className='text-center acuerdo-modalFME-titulo'><strong>SOLICITUD DE CREACIÓN DE CUENTA </strong></p>
                                <div className=' mb-3'>
                                    <img className="acuerdo-check " src={check} alt="Exitoso"></img>
                                </div>

                                {/*<p className='text-center acuerdo-modalFME-texto'>Su solicitud de creación de cuenta ha sido enviada*/}
                                {/*    exitosamente, en un lapso de 24 horas será revisada.</p>*/}
                                <p className='text-center acuerdo-modalFME-texto'><strong>Su solicitud de creación de cuenta electronica ha sido recibida exitosamente. </strong></p>

                                <div align="center" >
                                    <button onClick={this.cerrarModalFManualExitosa} className="modal-modalFM-botones" >ACEPTAR</button>
                                </div>
                            </Modal>
                        }
                        {
                            this.state.modalFManualExitosaTipoA &&
                            <Modal isOpen={this.state.modalFManualExitosaTipoA} cerrarModal={this.cerrarModalFManualExitosaTipoA} verBoton={false} textoBoton="SIGUIENTE" >
                                <p className='text-center acuerdo-modalFME-titulo'><strong>SOLICITUD DE CREACIÓN DE CUENTA AUTOMATICA USER TIPO A</strong></p>
                                <div className=' mb-3'>
                                    <img className="acuerdo-check " src={check} alt="Exitoso"></img>
                                </div>

                                {/*<p className='text-center acuerdo-modalFME-texto'>Su solicitud de creación de cuenta ha sido enviada*/}
                                {/*    exitosamente, en un lapso de 24 horas será revisada.</p>*/}
                                <p className='text-center acuerdo-modalFME-texto'><strong>Su solicitud de creación de cuenta electronica ha sido recibida exitosamente. </strong></p>

                                <div align="center" >
                                    <button onClick={this.cerrarModalFManualExitosa} className="modal-modalFM-botones" >ACEPTAR</button>
                                </div>
                            </Modal>
                        }

                        {
                            this.state.modalNoAcepACGeneral &&
                            <Modal isOpen={this.state.modalNoAcepACGeneral} cerrarModal={this.cerrarModalNoAcepACGeneral} verBoton={true} textoBoton="CERRAR">
                                <p className='text-center acuerdo-modalFME-titulo'><strong>ACUERDO NO ACEPTADO</strong></p>
                                <div className=' mb-3'>
                                    <img className="acuerdo-check " src={alerta} alt="Exitoso"></img>
                                    </div>
                                    <p className='text-center acuerdo-modalFME-texto'>Estimado, si usted tiene dudas respecto a la aceptación del acuerdo de tratamiento de datos personales para aspirantes a estudiantes de la ESPOL, ponemos a su disposición el correo de consulta <a href="mailto:datospersonales@espol.edu.ec" target="_blank">datospersonales@espol.edu.ec</a> con el proposito de aclararle sus inquietudes.</p>

                            </Modal>
                        }
                        {
                            this.state.modalNoAcepACGeneralprev &&
                            <Modal isOpen={this.state.modalNoAcepACGeneralprev} cerrarModal={this.cerrarModalNoAcepACGeneralPrev} verBoton={false} >
                                <p className='text-center acuerdo-modalFME-titulo'><strong>¿Está seguro que no desea aceptar el acuerdo?</strong></p>
                                <div className=' mb-3'>
                                    <img className="acuerdo-check " src={alerta} alt="Exitoso"></img>
                                </div>
                                    <p className='text-center acuerdo-modalFME-texto'>Si usted <strong>no acepta</strong> el acuerdo de uso de datos personales y medios electrónicos, no podrá acceder a los sistemas de la ESPOL.</p>
                                <div align="center" >
                                    <button onClick={this.cerrarModalNoAcepACGeneralPrev} className="modal-modalFM-botones ver-acuerdo" >Ver acuerdo</button>
                                    <button onClick={this.abrirModalNoAcepACGeneral} className="modal-modalFM-botones no-firmar" >No firmar</button>
                                </div>
                            </Modal>
                        }
                        { /*ADMISIONES */
                            this.state.modalFirmaGeneralExitosa &&
                            <Modal isOpen={this.state.modalFirmaGeneralExitosa} cerrarModal={this.cerrarModalFirmaGeneralExitosa} verBoton={true} textoBoton="ACEPTAR" >
                                <p className='text-center acuerdo-modalFME-titulo'><strong>ACUERDO ACEPTADO</strong></p>
                                <div className=' mb-3'>
                                    <img className="acuerdo-check " src={check} alt="Exitoso"></img>
                                </div>
                                    <p className='text-center acuerdo-modalFME-texto'><strong>Usted aceptó con éxito el acuerdo de tratamiento de datos personales para aspirantes a estudiantes de la ESPOL. </strong></p>
                            </Modal>
                        }

                        {
                            this.state.modalActualizaciónDocsExitosa &&
                            <Modal isOpen={this.state.modalActualizaciónDocsExitosa} cerrarModal={this.cerrarModalActualizaciónDocsExitosa} verBoton={false} textoBoton="SIGUIENTE" >
                                <p className='text-center acuerdo-modalFME-titulo'><strong>Documentos actualizados correctamente </strong></p>
                                <div className=' mb-3'>
                                    <img className="acuerdo-check " src={check} alt="Exitoso"></img>
                                </div>

                                {/*<p className='text-center acuerdo-modalFME-texto'>Su solicitud de creación de cuenta ha sido enviada*/}
                                {/*    exitosamente, en un lapso de 24 horas será revisada.</p>*/}
                                <p className='text-center acuerdo-modalFME-texto'><strong>Se actualizaron los documentos de su solicitud de creación de cuenta electrónica. </strong></p>
                                <p className='text-center acuerdo-modalFME-texto'><strong>Se notificará por correo el estado de su solicitud. </strong></p>

                                <div align="center" >
                                        <button onClick={this.cerrarModalActualizaciónDocsExitosa} className="modal-modalFM-botones" >ACEPTAR</button>
                                </div>
                            </Modal>
                        }
                    </div>
                )
        )
    }
}

export default AcuerdoAdmisiones
